import type { CSSProperties, ReactNode } from "react";
import { COLORS, MOTION, RADIUS } from "../theme/index.js";

type IconButtonProps = {
  onClick?: () => void;
  "aria-label": string;
  children: ReactNode;
  size?: "sm" | "md";
  style?: CSSProperties;
  disabled?: boolean;
};

export function IconButton({
  onClick,
  "aria-label": label,
  children,
  size = "md",
  style,
  disabled,
}: IconButtonProps) {
  const sz = size === "sm" ? 24 : 32;
  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      style={{
        width: sz,
        height: sz,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        border: "none",
        borderRadius: RADIUS.md,
        color: COLORS.textMuted,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: `background ${MOTION.fast} ${MOTION.ease}, color ${MOTION.fast} ${MOTION.ease}`,
        padding: 0,
        ...style,
      }}
    >
      {children}
    </button>
  );
}
